import { VFC } from "react";

import { Checkbox, FormControlLabel, TextInput } from "@portex-pro/ui-components";
import { useTranslation } from "react-i18next";

import { useQuoteRequestSelector } from "../_store";
import { quoteRequestActions } from "../_store/quoteRequestSliceV2";

const TemplateOption: VFC = () => {
  const { t } = useTranslation(["common", "shipper"]);
  const { templateName, createTemplate } = useQuoteRequestSelector((store) => store.quoteRequestSliceV2);
  const setState = quoteRequestActions.useSetState();

  return (
    <div className="flex space-x-2 items-center">
      <FormControlLabel
        control={<Checkbox checked={createTemplate} onChange={(_, checked) => setState({ createTemplate: checked })} />}
        label={t("shipper:saveAsTemplate")}
      />
      <TextInput
        value={templateName}
        onChange={(e) => setState({ templateName: e.target.value })}
        placeholder={t("shipper:enterTemplateName")}
      />
    </div>
  );
};

export default TemplateOption;
